export enum SupplierType {
    LinkedInLearning = 1,
    Unknown = 0,
    Microsoft365 = 2,
}